import { buildObjectFromPaths, optionGet } from '../../helpers/objects';
import { isWithinSmall } from '../../helpers/responsive';
import { liftA2 } from 'fp-ts/lib/Apply';
import { option } from 'fp-ts';

// GTM Event Data Keys
export const GTM_KEY_PROJECT_ID = 'projectId';
export const GTM_KEY_SCREEN_SIZE = 'screenSize';
export const GTM_KEY_WINDOW_SIZE = 'windowSize';
export const GTM_KEY_SITE_ID = 'siteId';
export const GTM_KEY_PRODUCT_SKU = 'productSku';
export const GTM_KEY_PRODUCT_CONFIGURABLE_SKU = 'productConfigurableSku';
export const GTM_KEY_PRODUCT_NAME = 'productName';
export const GTM_KEY_LOCATION = 'location';
export const GTM_KEY_REFERRER = 'pdpReferrer';

// GTM Event Names
export const GTM_EVENT_USER_SELECTED_OPTION = 'auPdpUserSelectedProductOption';
export const GTM_EVENT_USER_STARTED_PROJECT = 'startedProjectFromPDP';
export const GTM_EVENT_ADD_TO_CART = 'addedToCartFromPDP';
export const GTM_EVENT_CLICKED_SOCIAL = 'auPdpClickedSocial';

export const DEFAULT_GTM_DATA = {
  [GTM_KEY_SCREEN_SIZE]: `${optionGet('screen.width')(window).getOrElseValue(0)}x${optionGet('screen.height')(window).getOrElseValue(0)}`,
  [GTM_KEY_WINDOW_SIZE]: `${optionGet('outerWidth')(window).getOrElseValue(0)}x${optionGet('outerHeight')(window).getOrElseValue(0)}`,
  [GTM_KEY_SITE_ID]: isWithinSmall() ? 'mobile-web' : 'desktop',
  [GTM_KEY_PRODUCT_SKU]: '{state.product.sku}',
  [GTM_KEY_PRODUCT_NAME]: '{state.product.name}',
  [GTM_KEY_LOCATION]: 'pdp',
  [GTM_KEY_REFERRER]: optionGet('referrer')(document).getOrElseValue(''),
};

// Safely send GTM events based on presence of GTM in DOM
export const sendGtmEvent = (eventName: string) => (eventData: Object) => (dispatch: Function, getState: Function<Object>) => {
  if (!window.dataLayer) {
    return;
  }
  try {
    const formattedEventData = {
      ...DEFAULT_GTM_DATA,
      ...eventData,
      event: eventName,
    };
    const gtmData = buildObjectFromPaths(formattedEventData)({
      // This wrapping allows callers to use {state.product.sku} instead of {product.sku} for clarity
      state: getState(),
    });
    window.dataLayer.push(gtmData);
  } catch (e) {
    // Do nothing, just don't crash because of analytics.
    if (window.newrelic) {
      window.newrelic.noticeError(e);
    }
  }
};

const createSendAnalyticsFn = (eventName: string) => (eventData: Object) => sendGtmEvent(eventName)(eventData);
export const sendAnalyticsForStartProject = createSendAnalyticsFn(GTM_EVENT_USER_STARTED_PROJECT);
export const sendAnalyticsForAddToCart = createSendAnalyticsFn(GTM_EVENT_ADD_TO_CART);

const sendAnalyticsForOptionSelectionAction = (attributeLabel: string) => (optionLabel: string) => createSendAnalyticsFn(GTM_EVENT_USER_SELECTED_OPTION)({
  attributeLabel,
  optionLabel,
});

export const sendAnalyticsForOptionSelection = liftA2(option.option)(sendAnalyticsForOptionSelectionAction);



// WEBPACK FOOTER //
// ./src/store/modules/analytics.js